import styled from "styled-components/macro";
import { DefaultTheme } from "styled-components";
import { DeviceType } from "../../utils/hooks/useDeviceHook";
import { TextField } from "../shared/TextField/TextField";

export const ProfileInsuranceTextFieldLabel = styled.div`
  svg {
    width: 20px;
    margin-bottom: -4px;
  }
`;

export const PolicyOwnerRelationshipText = styled.div`
  p {
    font-family: light !important;
    font-size: 16px !important;
  }
`;

const getDateColor = (
  theme: DefaultTheme,
  error?: string,
  noDateValue?: boolean,
) => {
  if (error) return theme.redDark;
  if (noDateValue) return theme.neutral500;
  return theme.black;
};

export const ProfileInsuranceTextField = styled(TextField)<{
  $noDateValue?: boolean;
  $showHelpertext?: boolean;
}>`
  color: ${({ theme }) => theme.greyLight};
  width: 100%;
  font-family: light;

  input::-webkit-datetime-edit {
    color: ${({ theme, error, $noDateValue }) =>
      getDateColor(theme, error, $noDateValue)};
  }

  input::-webkit-date-and-time-value {
    margin-top: 0px;
    text-align: left;
    width: 100%;
  }

  .MuiFormHelperText-root {
    display: ${({ $showHelpertext }) => ($showHelpertext ? undefined : "none")};
    color: ${({ theme }) => theme.blueDark} !important;
  }

  .MuiFormHelperText-root.Mui-error {
    display: ${({ $showHelpertext }) => ($showHelpertext ? undefined : "none")};
    color: ${({ $showHelpertext, theme }) =>
      $showHelpertext ? theme.redDark : undefined} !important;
  }
`;

export const ProfileInsuranceInsurancePadding = styled.div<{ $show: boolean }>`
  padding-left: 30px;
  padding-right: 5px;
  padding-bottom: 15px;
  margin-top: 10px;
  display: ${({ $show }) => ($show ? undefined : "none")};

  ${".MuiFormLabel-root"} {
    font-size: 16px !important;
  }
`;
